import { useCallback } from "react"

import { useSettings } from "../modules/settings"
import { clampIndex } from "../modules/utils/utils"

/**
 * Position inside the current rule's sentence list. It lives in
 * `appSettings.selectCorrect.index[rule]`, so the game's next button and the
 * sidebar's position slider write the same value, and every rule keeps its own
 * position across reloads.
 */
export function useSelectCorrectIndex(input: {
  length: number
  rule: string
}) {
  const { appSettings, setAppSettings } = useSettings()
  const storedIndex = appSettings.selectCorrect.index[input.rule] ?? 0
  const lastIndex = Math.max(input.length - 1, 0)
  const currentIndex = clampIndex(storedIndex, lastIndex + 1)
  const setCurrentIndex = useCallback(
    (nextIndex: number)=> {
      setAppSettings(
        "index",
        {
          ...appSettings.selectCorrect.index,
          [input.rule]: clampIndex(nextIndex, lastIndex + 1),
        },
        "selectCorrect",
      )
    },
    [appSettings.selectCorrect.index, input.rule, lastIndex, setAppSettings],
  )

  return { currentIndex, lastIndex, setCurrentIndex }
}
